import { useFieldContext } from "../form";
import { TextField } from "./text-field";

export type NumberFieldProps = {
	label: string;
	required?: boolean;
};

export function NumberField({ label, required }: NumberFieldProps) {
	const field = useFieldContext();
	return (
		<TextField
			label={label}
			onChange={(e) => field.handleChange(e.target.valueAsNumber)}
			inputMode="numeric"
			required={required}
		/>
	);
}
